export const isNotNullUnDef = (str) => {
  if (str !== null && str !== undefined) return true;
  return false;
};

export const isNotnulUnDefEmpty = (str) => {
  if (str !== null && str !== undefined && str.length() > 0) return true;
  return false;
};

export const isNotNullUnDefNA = (str) => {
  if (str !== null && str !== undefined && str !== 'NA') return true;
  return false;
};
